import React from 'react';
import './SectionHeader.css';

export interface SectionHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  action?: React.ReactNode;
}

export const SectionHeader = React.forwardRef<HTMLDivElement, SectionHeaderProps>(
  ({ label, action, className = '', ...rest }, ref) => (
    <div ref={ref} className={`a-section-header ${className}`.trim()} {...rest}>
      <span className="a-section-header__label">{label}</span>
      {action && <span className="a-section-header__action">{action}</span>}
    </div>
  )
);
SectionHeader.displayName = 'SectionHeader';
